export default {
  MENU_TITLE: "Equipment transfers",
  STATUS_DRAFT: "Draft",
  STATUS_SUBMITTED: "Submitted",
  STATUS_ACCEPTED: "Accepted",
  STATUS_REJECTED: "Rejected",
  STATUS_CANCELED: "Canceled",
  STATUS_PARTIALLY_RETURNED: "Partially returned",
  STATUS_RETURNED: "Returned",
  TYPE_TEMPORARY: "Temporary",
  TYPE_PERMANENT: "Permanent",
  TRANSFER_TYPE: "Transfer type",
  TRANSFER_DATE: "Transfer date",
  RETURN_DATE: "Return date",
  RETURN: "Return",
  RETURN_ALL: "Return all",
  RETURNED_AT: "Returned at",
  RETURNED_BY: "Returned by",
  ON_LOAN: "On loan",
  AVAILABLE: "Available",
  LOAN_STATUS: "Loan status",
  LOANED_TO: "On loan at",
  OVERDUE_RETURN: "Overdue return",
  OVERDUE_RETURNS_TITLE: "Overdue equipment returns",
  TO_VALIDATE_TITLE: "Equipment transfers to validate",
  EQUIPMENT: "Equipment",
  EQUIPMENTS: "Equipments",
  SELECT_EQUIPMENT: "Select an equipment",
  ADD_EQUIPMENT_TRANSFER: "Add an equipment transfer",
  EDIT_EQUIPMENT_TRANSFER: "Edit an equipment transfer",
  DELETE_EQUIPMENT_TRANSFER: "Delete the equipment transfer",
  ADD_ITEMS_FIRST: "Add at least one equipment before submitting.",
  INCLUDE: "Include",
  NO_AVAILABLE_EQUIPMENT: "No equipment available for this establishment.",
  SELECTED_COUNT: "{count} equipment selected",
  EQUIPMENT_ALREADY_ON_LOAN: "This equipment is already on loan.",
  SUBMITTED_BY: "Submitted by",
  SUBMITTED_AT: "Submitted at",
  ACCEPTED_BY: "Accepted by",
  ACCEPTED_AT: "Accepted at",
  SOURCE_ESTABLISHMENT: "Source establishment",
  DESTINATION_ESTABLISHMENT: "Destination establishment",
  CURRENTLY_TRANSFERRED: "Currently transferred",
  SERIAL_NUMBER: "Serial number",
  BRAND: "Brand",
  QUANTITY: "Quantity",
  ACCEPT: "Accept",
  REJECT: "Reject",
  REVERT_TO_DRAFT: "Revert to draft",
  SOURCE_DESTINATION_MUST_DIFFER:
    "The source and destination establishments must be different.",
  RETURN_DATE_REQUIRED: "The return date is required for a temporary transfer.",
  SUBMIT: "Validate and submit",
  SUBMIT_QUESTION: "Submit the equipment transfer to the destination establishment?",
  EQUIPMENT_TRANSFER_SUBMITTED: "Equipment transfer submitted",
  ACCEPT_QUESTION: "Accept this equipment transfer?",
  EQUIPMENT_TRANSFER_ACCEPTED: "Equipment transfer accepted",
  REJECT_QUESTION: "Reject this equipment transfer?",
  EQUIPMENT_TRANSFER_REJECTED: "Equipment transfer rejected",
  CANCEL_QUESTION: "Cancel this equipment transfer?",
  EQUIPMENT_TRANSFER_CANCELED: "Equipment transfer canceled",
  REVERT_TO_DRAFT_QUESTION: "Move the equipment transfer back to draft?",
  EQUIPMENT_TRANSFER_REVERTED: "Equipment transfer moved back to draft",
  RETURN_ALL_QUESTION: "Confirm the return of every equipment of this transfer?",
  EQUIPMENT_TRANSFER_RETURNED: "Equipments returned",
  EQUIPMENT_ITEM_RETURNED: "Equipment returned",
  SUBMITTER_CANNOT_DECIDE:
    "You created or submitted this transfer: accepting or rejecting it is up to the destination establishment.",
  ONLY_AUTHOR_CAN_REVERT: "Only the author of the transfer can revert it to draft.",
  SEND_BY_MAIL: "Send by email",
  SEND_NOW_QUESTION: "Send the equipment transfer now?",
  SEND_NOW_HINT:
    "You can send the transfer to the destination establishment right away to avoid forgetting.",
  MAIL_SENT_AT: "Sent at",
  MAIL_SENT_BY: "Sent by",
  VIEW_TRANSFER: "View the transfer",
};
